import { auToneSurfaceSx } from '@/theme/au-compat';
import { msg } from '@lingui/macro';
import { useLingui } from '@lingui/react';
import { ArrowDownward, ArrowUpward, Block } from '@mui/icons-material';
import { Box, Tooltip } from '@mui/material';
import { type FC, type ReactNode } from 'react';
import type { GateLiveStatusState } from '../hooks/useGateLiveStatus';

/** Bloqueos activos que reporta el equipo, en paralelo; sin bloqueos activos no se muestra nada. */
export const LiveBlocks: FC<{ live: GateLiveStatusState }> = ({ live }) => {
  const { _ } = useLingui();
  const reading = live.awaiting ? null : live.reading;
  if (!reading) return null;

  const blocks: { key: string; label: string; icon: ReactNode; codes?: string[] | null }[] = [
    { key: 'all', label: _(msg`Bloqueo general`), icon: <Block />, codes: reading.blockedBy },
    {
      key: 'open',
      label: _(msg`Bloqueo de apertura`),
      icon: <ArrowUpward />,
      codes: reading.blockedOpenBy,
    },
    {
      key: 'close',
      label: _(msg`Bloqueo de cierre`),
      icon: <ArrowDownward />,
      codes: reading.blockedCloseBy,
    },
  ];
  const active = blocks.filter((block) => block.codes && block.codes.length > 0);
  if (active.length === 0) return null;

  return (
    <Box sx={{ display: 'flex', flexWrap: 'wrap', gap: '8px' }}>
      {active.map(({ key, label, icon, codes }) => {
        const text = `${label}: ${codes!.join(', ')}`;
        return (
          <Tooltip key={key} title={text}>
            <Box
              role="img"
              aria-label={text}
              sx={{
                ...auToneSurfaceSx('error', { padding: '4px 10px' }),
                display: 'inline-flex',
                alignItems: 'center',
                gap: '6px',
                fontSize: 12,
                fontWeight: 600,
                '& svg': { fontSize: 16 },
              }}
            >
              {icon}
              {codes!.join(', ')}
            </Box>
          </Tooltip>
        );
      })}
    </Box>
  );
};
